import { Box, useTheme, Typography, TextField } from "@mui/material";
import { tokens } from "../../theme";
import LoadingButton from "@mui/lab/LoadingButton";
import {
	USER_INTIIAL_INPUT,
	USER_INTIIAL_INPUT_VALUES
} from "../../store/reducer/reducer.initials";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useFormik, getIn } from "formik";
import * as yup from "yup";

const CredCardUser = ({
	handleChange,
	handleSubmitForm,
	valuesForm,
	createUserLoader,
	resetUserForm
}) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");

	const TestaCPF = strCPF => {
		if(strCPF){
		var Soma;
		var Resto;
		Soma = 0;
		if (strCPF === "00000000000") return false;

		for (let i = 1; i <= 9; i++)
			Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
		Resto = Soma * 10 % 11;

		if (Resto === 10 || Resto === 11) Resto = 0;
		if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

		Soma = 0;
		for (let i = 1; i <= 10; i++)
			Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
		Resto = Soma * 10 % 11;

		if (Resto === 10 || Resto === 11) Resto = 0;
		if (Resto !== parseInt(strCPF.substring(10, 11))) return false;

		return true;
	}
	};

	const validationSchema = yup.object({
		email: yup
			.string("Enter your email")
			.email("Enter a valid email")
			.required("Este Campo é Obrigatório"),
		name: yup
			.string("Insira o seu nome confor o cartão")
			.min(1)
			.max(60)
			.required("Este Campo é Obrigatório"),
		cpfCnpj: yup
			.string("Insira seu CPF")
			.min(11, "Insira um CPF Válido")
			.max(11, "Insira um CPF Válido")
			.test("validator-custom-name", function(value) {
				const validation = TestaCPF(value);
				if (validation === false) {
					return this.createError({
						path: this.path,
						message:
							"Por favor insira um CPF Válido"
					});
				} else {
					return true;
				}
			})
			.required("Este Campo é Obrigatório"),
		postalCode: yup
			.string("Insira seu CEP")
			.min(8, "Insira um CEP Válido")
			.max(8, "Insira um CEP Válido")
			.required("Este Campo é Obrigatório"),
		addressNumber: yup
			.string("Insira o número do seu endereço")
			.required("Este Campo é Obrigatório"),
		phone: yup
			.string("Insira o número do seu telefone")
			.required("Este Campo é Obrigatório")
	});

	const formik = useFormik({
		initialValues: USER_INTIIAL_INPUT_VALUES,
		validationSchema: validationSchema,
		validateOnMount: true,
		onSubmit: (values, actions) => {
			handleSubmitForm(values);
			actions.setSubmitting(false);
			if (resetUserForm) {
				actions.resetForm({
					values: USER_INTIIAL_INPUT_VALUES
				});
			}
		}
	});

	return (
		<Box>
			<Box
				m="10px"
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				sx={{
					width: "100%"
				}}
			>
				<Typography variant="h3" color={colors.yellow[600]} sx={{fontStyle: "italic"}}>
					Dados do Titular do Cartão
				</Typography>
			</Box>
			<form onSubmit={formik.handleSubmit}>
				<Box
					display="grid"
					gap="10px"
					gridTemplateColumns="repeat(12, minmax(0, 1fr))"
					sx={{
						width: "100%"
					}}
				>
					{USER_INTIIAL_INPUT.map((input, index) => {
						return (
							<TextField
								key={index}
								fullWidth
								variant="outlined"
								id={input.name}
								type={input.type}
								label={input.label}
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
								name={input.name}
								value={formik.values[input.name]}
								placeholder={input.placeholder}
								inputProps={{
									maxLength: input.maxLen
								}}
								// required
								sx={{
									gridColumn: "span 12",
									width: "100%",
									"& .MuiInputBase-root": {
										backgroundColor: `${colors
											.pink[600]} !important`
									},
									"& .MuiFormHelperText-root": {
										// color: `${colors.redAccent[600]} !important`,
										color: `yellow !important`,
										fontSize: "12px",
										fontStyle: "italic"
									},
									"& MuiInputBase-root.Mui-focused": {
										color: `${colors.grey[200]} !important`,
										fontWeight: "bold"
									},
									"& .MuiFormLabel-root.Mui-focused": {
										color: `${colors.grey[200]} !important`,
										fontWeight: "bold",
										fontSize: "12px"
									}
								}}
								errors={
									getIn(!!formik.touched, input.name) &&
									Boolean(getIn(!!formik.errors, input.name))
								}
								helperText={
									getIn(formik.touched, input.name) &&
									getIn(formik.errors, input.name)
								}
								// error={!!formik.touched[input.name] && Boolean(!!formik.errors[input.name])}
								// helperText={formik.touched[input.name] && formik.errors[input.name]}
							/>
						);
					})}
				</Box>
				<Box
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="center"
					sx={{
						width: "100%",
						marginTop: "10px"
					}}
				>
					<LoadingButton
						loading={createUserLoader}
						type="submit"
						sx={{
							backgroundColor: colors.greenAccent[600],
							width: isNonMobile ? "100%" : "100%",
							borderRadius: "60px"
						}}
						variant="contained"
					>
						Avançar
					</LoadingButton>
				</Box>
			</form>
		</Box>
	);
};

export default CredCardUser;
